export const validation = {
  promoCodeSuccess: 'Promocode applied successfully',
  invalidPromoCode: 'Please enter valid promo code',
};
